export default __webpack_public_path__ + "static/media/payment_images.201e1877.webp";